// only allows for postive numbers
// no letters or special characters besides decimal point.
export const isPositiveFloat = (value: string) => {
  const regex = /^\d*\.?\d*$/;
  return regex.test(value) && !value.startsWith('-');
};
